import { ModuleWithProviders, NgModule } from '@angular/core';
import {
    DefaultFallbackStrategy,
    DefaultTranspiler,
    TRANSLOCO_CONFIG,
    TRANSLOCO_FALLBACK_STRATEGY,
    TRANSLOCO_INTERCEPTOR,
    TRANSLOCO_LOADER,
    TRANSLOCO_MISSING_HANDLER,
    TRANSLOCO_TRANSPILER,
    Translation,
    TranslocoConfig,
    TranslocoInterceptor,
    TranslocoMissingHandler,
    TranslocoMissingHandlerData,
    translocoConfig,
    TranslocoModule,
} from '@ngneat/transloco';
import { HttpClientModule } from '@angular/common/http';
import { FLOORI_ENV, FLOORI_TRANSLATOR } from '../../constants';
import { Languages } from '../../models';
import { TranslationsEnv } from './models/translations-env';
import { FlooriTranslationService } from './services/floori-translation.service';
import { TranslationsLoaderService } from './services/translations-loader.service';
import { TranslatePipe } from './pipes/translate.pipe';

class DefaultMissingHandler implements TranslocoMissingHandler {
    handle(key: string, data: TranslocoMissingHandlerData): string {
        if (data.missingHandler?.logMissingKey && !data.prodMode) {
            console.warn(`Missing translation for key: ${key}`);
        }
        return key;
    }
}

class DefaultInterceptor implements TranslocoInterceptor {
    preSaveTranslation(translation: Translation, _lang: string): Translation {
        return translation;
    }

    preSaveTranslationKey(_key: string, value: string, _lang: string): string {
        return value;
    }
}

const exported = [TranslatePipe];

@NgModule({
    imports: [HttpClientModule, ...exported],
    exports: [TranslocoModule, ...exported],
    providers: [TranslatePipe],
})
export class TranslationsModule {
    static forRoot(): ModuleWithProviders<TranslationsModule> {
        return {
            ngModule: TranslationsModule,
            providers: [
                TranslatePipe,
                {
                    provide: TRANSLOCO_CONFIG,
                    useFactory: (env: TranslationsEnv): TranslocoConfig => {
                        return translocoConfig({
                            prodMode: env.production,
                            reRenderOnLangChange: true,
                            defaultLang: Languages.en,
                        });
                    },
                    deps: [FLOORI_ENV],
                },
                {
                    provide: TRANSLOCO_TRANSPILER,
                    useClass: DefaultTranspiler,
                },
                {
                    provide: TRANSLOCO_MISSING_HANDLER,
                    useClass: DefaultMissingHandler,
                },
                {
                    provide: TRANSLOCO_INTERCEPTOR,
                    useClass: DefaultInterceptor,
                },
                {
                    provide: TRANSLOCO_FALLBACK_STRATEGY,
                    useClass: DefaultFallbackStrategy,
                },
                {
                    provide: FLOORI_TRANSLATOR,
                    useClass: FlooriTranslationService,
                },
                {
                    provide: TRANSLOCO_LOADER,
                    useExisting: TranslationsLoaderService,
                },
            ],
        };
    }
}
